import React from 'react';
import { useParams } from 'react-router-dom';
import useMultiGame from '../../hooks/useMultiGame';
import GameScreen from '../GameScreen';
import TurnStatusBar from './TurnStatusBar';
import VoteEndBanner from './VoteEndBanner';
import MultiGameOver from './MultiGameOver';
import { Loader2 } from 'lucide-react';

const MultiGameScreen = ({ refreshGameState, stat }) => {
  const { gameId } = useParams();
  const {
    gameState, multiState, gridData, loading, turnResolved,
    fetchGameState, submitTurn, voteEnd, setGameState,
  } = useMultiGame(gameId);

  // Dériver le username du joueur courant
  const yourUsername = multiState?.players?.find(
    p => p.country_short_name === multiState.your_country
  )?.username;

  if (loading && !gameState) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-blue-400 animate-spin" />
      </div>
    );
  }

  // Game over
  if (multiState?.status === 'finished') {
    return <MultiGameOver multiState={multiState} />;
  }

  if (!gameState) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <p className="text-red-400">Impossible de charger la partie</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen">
      <TurnStatusBar multiState={multiState} onVoteEnd={voteEnd} />
      {multiState?.active_vote && (
        <VoteEndBanner
          activeVote={multiState.active_vote}
          yourUsername={yourUsername}
          onVoteEnd={voteEnd}
        />
      )}
      <div className="flex-1 overflow-hidden">
        <GameScreen
          initialGameState={gameState}
          refreshGameState={fetchGameState}
          stat={stat}
          isMulti={true}
          multiState={multiState}
          submitMultiTurn={submitTurn}
          gridData={gridData}
          turnResolved={turnResolved}
        />
      </div>
    </div>
  );
};

export default MultiGameScreen;
